module.exports = __webpack_public_path__ + "static/media/ios-pulse.ed9df7e5.svg";